var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "hour-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v(_vm._s(_vm.$t("form.fieldLabel")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.hour.fieldLabel,
            expression: "item.hour.fieldLabel",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "field-label", placeholder: "Saat" },
        domProps: { value: _vm.item.hour.fieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.hour, "fieldLabel", $event.target.value)
            },
            function ($event) {
              return _vm.setFieldLabel(_vm.item.hour.fieldLabel)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.labelAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "left" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("left")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.left")) + "\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "right" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("right")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.right")) + "\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "top" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("top")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.top")) + "\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.chooseLabelAlignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.required"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.isRequired },
            on: { click: _vm.toggleRequired },
          },
          [_vm._v(_vm._s(_vm.requiredText))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.fieldEmptyError"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.visibility },
            on: { click: _vm.toggleVisibility },
          },
          [_vm._v(_vm._s(_vm.visibility ? "Görünür" : "Gizli"))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu alanın form üzerinde görünür olup olmayacağını belirler"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "slug-input" } }, [
        _vm._v("URL Parametresi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.slug,
            expression: "slug",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "slug-input", placeholder: "hour" },
        domProps: { value: _vm.slug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.slug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabels"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-labels" }, [
        _c("div", { staticClass: "sub-label-item" }, [
          _c("label", { staticClass: "sub-label", attrs: { for: "hour" } }, [
            _vm._v(_vm._s(_vm.$t("ticimax.time"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.item.hour.hourLabel,
                expression: "item.hour.hourLabel",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "hour",
              placeholder: _vm.$t("ticimax.time"),
            },
            domProps: { value: _vm.item.hour.hourLabel },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item.hour, "hourLabel", $event.target.value)
                },
                function ($event) {
                  return _vm.setHourLabel(_vm.item.hour.hourLabel)
                },
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub-label-item" }, [
          _c("label", { staticClass: "sub-label", attrs: { for: "minute" } }, [
            _vm._v(_vm._s(_vm.$t("report.minute"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.item.hour.minuteLabel,
                expression: "item.hour.minuteLabel",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "minute",
              placeholder: _vm.$t("report.minute"),
            },
            domProps: { value: _vm.item.hour.minuteLabel },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item.hour, "minuteLabel", $event.target.value)
                },
                function ($event) {
                  return _vm.setMinuteLabel(_vm.item.hour.minuteLabel)
                },
              ],
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }